import store from '@/store';
import { canAccessFeature, canAccessEntity } from './access';

export function canAccessRoute(routeOrPath, router) {
  let route;

  if (typeof routeOrPath === 'string') {
    route = router.resolve(routeOrPath);
  } else {
    route = routeOrPath;
  }

  if (route.meta.requiresSuperUser) {
    const isSuperUser = store.getters['auth/current_user']?.is_superuser;
    if (!isSuperUser) {
      return false;
    }
  }

  if (route.meta.canAccess) {
    // Check if user has access to the feature. Routes with `staffBypass` also
    // admit Kairon staff without the tenant feature flag (used by the
    // consolidated /support workspace: staff get in, customers need
    // MODULE_SERVICE_DESK). Superusers are NOT checked here — canAccessFeature
    // already grants them access, so adding is_superuser would be duplicative.
    const isStaff = !!store.getters['auth/current_user']?.is_staff;
    const hasFeatureAccess = canAccessFeature(route.meta.canAccess);
    if (!hasFeatureAccess && !(route.meta.staffBypass && isStaff)) {
      return false;
    }
  }
  
  if (route.params.entity_id) {
    const entityId = Number(route.params.entity_id);
    if (!canAccessEntity(entityId)) {
      return false;
    }
  }

  if (
    route.meta.layout !== 'portal' &&
    route.meta.layout !== 'external' &&
    route.name !== 'Home' &&
    route.name !== 'ForbiddenPage' &&
    store.getters['tenant/isRestrictedToPortal']
  ) {
    return false;
  }


  return true;
}
